import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export const ContainerGrid = styled.div`
  padding: 0px 20px 20px 20px;

  && .dx-datagrid-nowrap .dx-header-row > td > .dx-datagrid-text-content {
    font-size: 15px;
    color: #000;
    font-weight: 600;
    font-family: Muli;
  }

  && .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td {
    font-size: 15px;
    font-weight: normal;
    font-family: Muli;
  }
  && tr.dx-row.dx-header-row {
    height: 56px;
  }

  && .dx-datagrid-rowsview .dx-row.dx-row-lines {
    height: 56px;
    cursor: pointer;
  }

  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-command-select {
    padding-left: 0;
  }
  && .dx-pager .dx-pages .dx-selection {
    background: #5890aa;
  }
  && .dx-checkbox-checked .dx-checkbox-icon,
  .dx-checkbox-indeterminate .dx-checkbox-icon {
    background: #5890aa;
  }
`;

export const contaStyles = makeStyles({
  descricaoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  badgePrincipal: {
    backgroundColor: '#54c6e8',
    color: '#ffffff',
    margin: 8,
    marginRight: 12,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 12,
    fontWeight: 600,
  },
  badgeEncerrada: {
    backgroundColor: '#9f9f9f',
    color: '#ffffff',
    margin: 8,
    marginRight: 12,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 12,
    fontWeight: 600,
  },
  descricao: {
    textOverflow: 'ellipsis',
    maxWidth: 165,
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  saldoNegativo: {
    color: '#f44336',
  },
  partnerBank: {
    marginLeft: 10,
  },
});
